<div class="p-container p-3">
  <!-- Top Section -->
  <div class="mb-8">
    <h2 class="text-2xl font-bold text-foreground">Diet Summary</h2>
    <p class="text-gray-500 mt-1">View and manage all uploaded diet summary documents.</p>
  </div>

  <!-- Cards -->
  <div
    *ngIf="dietSummaryDetails.length > 0"
    class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
  >
    <div
      *ngFor="let item of dietSummaryDetails"
      (click)="openDietSummary(item)"
      class="group cursor-pointer bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-6 border border-gray-100 hover:border-blue-300"
    >
      <!-- Top Row -->
      <div class="flex justify-between items-center mb-4">
        <div class="flex items-center gap-4">
          <div
            class="bg-orange-100 text-foreground p-3 rounded-xl group-hover:bg-primary group-hover:text-white transition"
          >
            <i class="pi pi-file text-lg"></i>
          </div>

          <div>
            <h3 class="text-lg font-semibold text-foreground">Diet Summary</h3>

            <p class="text-sm text-gray-500">
              {{ item.created_date | date: 'mediumDate' }}
            </p>
          </div>
        </div>

        <i class="pi pi-angle-right text-gray-400 group-hover:text-blue-500"></i>
      </div>

      <!-- Bottom Button -->
      <button
        class="mt-6 w-full bg-primary text-white text-sm py-2 rounded-lg transition flex items-center justify-center gap-2"
      >
        <i class="pi pi-eye"></i>
        View Summary
      </button>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="dietSummaryDetails.length === 0" class="flex justify-center items-center mt-10">
    <div
      class="w-full max-w-md bg-card rounded-2xl shadow-md border border-gray-100 p-8 text-center"
    >
      <!-- Icon -->
      <div
        class="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-orange-100 text-orange-500 mb-4"
      >
        <i class="pi pi-inbox text-2xl"></i>
      </div>

      <!-- Title -->
      <h3 class="text-lg font-semibold text-foreground mb-2">No Diet Summary Found</h3>

      <!-- Description -->
      <p class="text-sm text-gray-500 mb-5">
        There is no diet summary available for this assessment yet.
      </p>
    </div>
  </div>
</div>
